import { updateClientCityRangeRequest } from "../../data/clientCityRangeApi";
import { validateClientCityRangePayload } from "../validator/validateClientCityRangePayload";

export async function updateClientCityRangeUseCase(payload) {
  if (!Number.isInteger(Number(payload?.id)) || Number(payload?.id) <= 0) {
    throw new Error("El id de la tarifa por rango es obligatorio.");
  }

  const error = validateClientCityRangePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await updateClientCityRangeRequest(payload);
}
